import { NgRedux } from '@ptl/angular-redux-store';
import { Pipe, PipeTransform } from '@angular/core';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProducerProspectPaginatorStateStructure, PRODUCER_PROSPECT_PAGINATOR_REDUCER_NAME } from '../reducers/producer-prospect-paginator.reducer';
import { Prospect } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-prospects-retrieval.producer.response.interface';

@Pipe({
    name: 'producerProspectPaginator',
    pure: false,
    standalone: false
})
export class ProducerProspectPaginatorPipe implements PipeTransform {

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  transform(prospects: Prospect[], ...args: unknown[]): unknown {
    const producerProspectPaginator: ProducerProspectPaginatorStateStructure
      = this.reducerUtilityService.getComponentStates()[PRODUCER_PROSPECT_PAGINATOR_REDUCER_NAME];

    const pageIndex = producerProspectPaginator.pageIndex;
    const pageSize = producerProspectPaginator.pageSize;

    if (pageIndex === undefined || !pageSize) {
      return prospects;
    }

    return prospects.sort((a, b) => b.status.timestamp - a.status.timestamp).filter((item, index) => {
      return (
        index < (pageIndex + 1) * pageSize &&
        index >= pageIndex * pageSize
      )
    });
  }

}
